<div class="company-employees" [formGroup]="form">
  <div class="company-employees-section">
    <a class="company-employees-section-download"
      href="https://drive.google.com/uc?export=download&id=1NXRKnxDAvgLSnwtPHz_Eo_oVXOHYNoww">
      <div class="company-employees-section-download-content">
        <p><b>{{ "company.employees.download.title" | translate }}</b></p>
        <p><b>{{ "company.employees.download.subtitle" | translate }}</b></p>
        <ul>
          <ol [innerHTML]="'company.employees.download.items.item1' | translate"></ol>
          <ol [innerHTML]="'company.employees.download.items.item2' | translate"></ol>
          <ol [innerHTML]="'company.employees.download.items.item3' | translate"></ol>
          <ol [innerHTML]="'company.employees.download.items.item4' | translate"></ol>
          <ol [innerHTML]="'company.employees.download.items.item5' | translate"></ol>
          <ol [innerHTML]="'company.employees.download.items.item6' | translate"></ol>
        </ul>
      </div>
    </a>
    <div class="company-employees-section-wrapper">
      <img [src]="getEmployeesSvg" alt="delete" />
      <span>{{ "company.employees.info" | translate }}</span>
      <div class="select-csv-container">
        <div (click)="fileSelect.click()" class="action-employees">
          <cowing-button [label]="'company.employees.select_csv' | translate" [type]="EButtonType.Primary"
            [iconShow]="false">
          </cowing-button>
          <div *ngIf="csvDataChecked" class="checked-csv">
            <img [src]="getCircleChecked" alt="" />
          </div>
        </div>
        <div class="csv-errors">
          <span *ngIf="hasCsvErrorHeaders">
            {{ "company.employees.csv_incorrect_format" | translate }}
          </span>
          <span *ngIf="hasCsvErrorData">
            {{ "company.employees.csv_incorrect_data" | translate }}
          </span>
          <span *ngIf="hasCsvError">
            {{ "company.employees.csv_incorrect" | translate }}
          </span>
        </div>
        <input #fileSelect (input)="importCSV($event)" id="fileSelect" type="file"
          accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" />
      </div>
    </div>
  </div>
  <div *ngIf="isEditingInfo" class="actions-footer">
    <cowing-button [label]="'coworking.cancel' | translate" [type]="EButtonType.RoundedSecondary" [iconShow]="false"
      (event)="goBack()">
    </cowing-button>
    <cowing-button [disabled]="isDisabledForm" [label]="'general.save' | translate" [type]="EButtonType.Rounded"
      [iconShow]="false" (event)="putEmployees()">
    </cowing-button>
  </div>
</div>
